import React from 'react';

export default function Inspector({ styles, setStyles }) {
  const handleChange = (key, value) => {
    setStyles(prev => ({ ...prev, [key]: value }));
  };

  return (
    <div className="p-5 flex flex-col gap-6">
      <div>
        <h2 className="text-lg font-bold mb-4">Typography Engine</h2>
        
        <div className="space-y-4 text-sm">
          <div>
            <label className="block text-gray-400 mb-1">Font Family</label>
            <select 
              value={styles.fontFamily}
              onChange={e => handleChange('fontFamily', e.target.value)}
              className="w-full bg-gray-800 border border-gray-700 rounded p-2"
            >
              <option value="Inter">Inter</option>
              <option value="Montserrat">Montserrat</option>
              <option value="Oswald">Oswald</option>
              <option value="Comic Sans MS">Comic Sans MS</option>
            </select>
          </div>
          
          <div>
            <label className="block text-gray-400 mb-1">Font Size ({styles.fontSize}px)</label>
            <input 
              type="range" min="20" max="120" 
              value={styles.fontSize}
              onChange={e => handleChange('fontSize', Number(e.target.value))}
              className="w-full accent-emerald-500"
            />
          </div>

          <div className="flex gap-4">
            <div className="flex-1">
              <label className="block text-gray-400 mb-1">Text Color</label>
              <input 
                type="color" 
                value={styles.textColor}
                onChange={e => handleChange('textColor', e.target.value)}
                className="w-full h-8 bg-transparent cursor-pointer"
              />
            </div>
            <div className="flex-1">
              <label className="block text-gray-400 mb-1">Active Color</label>
              <input 
                type="color" 
                value={styles.activeColor}
                onChange={e => handleChange('activeColor', e.target.value)}
                className="w-full h-8 bg-transparent cursor-pointer"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="h-px bg-gray-800 w-full"></div>

      <div>
        <h2 className="text-lg font-bold mb-4">Effects</h2>
        
        <div className="space-y-4 text-sm">
          <label className="flex items-center gap-2 cursor-pointer">
            <input 
              type="checkbox" 
              checked={styles.strokeEnabled}
              onChange={e => handleChange('strokeEnabled', e.target.checked)}
              className="accent-emerald-500"
            />
            <span>Enable Outline (Stroke)</span>
          </label>
          
          {styles.strokeEnabled && (
            <div className="pl-6 space-y-3 border-l-2 border-gray-800 ml-1">
              <div>
                <label className="block text-gray-400 mb-1">Stroke Color</label>
                <input 
                  type="color" 
                  value={styles.strokeColor}
                  onChange={e => handleChange('strokeColor', e.target.value)}
                  className="w-full h-8 bg-transparent cursor-pointer"
                />
              </div>
              <div>
                <label className="block text-gray-400 mb-1">Stroke Width ({styles.strokeWidth}px)</label>
                <input 
                  type="range" min="1" max="10" 
                  value={styles.strokeWidth}
                  onChange={e => handleChange('strokeWidth', Number(e.target.value))}
                  className="w-full accent-emerald-500"
                />
              </div>
            </div>
          )}

          <label className="flex items-center gap-2 cursor-pointer mt-4">
            <input 
              type="checkbox" 
              checked={styles.glowEnabled}
              onChange={e => handleChange('glowEnabled', e.target.checked)}
              className="accent-emerald-500"
            />
            <span>Enable Neon Glow</span>
          </label>

          {styles.glowEnabled && (
            <div className="pl-6 space-y-3 border-l-2 border-gray-800 ml-1">
              <div>
                <label className="block text-gray-400 mb-1">Glow Color</label>
                <input 
                  type="color" 
                  value={styles.glowColor}
                  onChange={e => handleChange('glowColor', e.target.value)}
                  className="w-full h-8 bg-transparent cursor-pointer"
                />
              </div>
              <div>
                <label className="block text-gray-400 mb-1">Blur Amount ({styles.glowBlur})</label>
                <input 
                  type="range" min="1" max="50" 
                  value={styles.glowBlur}
                  onChange={e => handleChange('glowBlur', Number(e.target.value))}
                  className="w-full accent-emerald-500"
                />
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="h-px bg-gray-800 w-full"></div>

      <div>
        <h2 className="text-lg font-bold mb-4">Visualizer</h2>
        
        <div className="space-y-4 text-sm">
          <label className="flex items-center gap-2 cursor-pointer mt-4">
            <input 
              type="checkbox" 
              checked={styles.visualizerEnabled || false}
              onChange={e => handleChange('visualizerEnabled', e.target.checked)}
              className="accent-emerald-500"
            />
            <span>Enable Visualizer</span>
          </label>

          {styles.visualizerEnabled && (
            <div className="pl-6 mt-3 space-y-3 border-l-2 border-gray-800 ml-1">
              <div>
                <label className="block text-gray-400 mb-1">Style</label>
                <select 
                  value={styles.visualizerStyle || 'bars'}
                  onChange={e => handleChange('visualizerStyle', e.target.value)}
                  className="w-full bg-gray-800 border border-gray-700 rounded p-2 text-sm"
                >
                  <option value="bars">Frequency Bars</option>
                  <option value="circle">Pulsing Circle</option>
                </select>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="h-px bg-gray-800 w-full"></div>

      <div>
        <h2 className="text-lg font-bold mb-4">Animation</h2>
        <label className="block text-gray-400 mb-1 text-sm">Preset</label>
        <select 
          value={styles.animationPreset}
          onChange={e => handleChange('animationPreset', e.target.value)}
          className="w-full bg-gray-800 border border-gray-700 rounded p-2 text-sm"
        >
          <option value="none">None (Static)</option>
          <option value="fade">Smooth Fade (Neo-Soul)</option>
          <option value="pop-in">Pop-in (Hip-Hop)</option>
        </select>
      </div>
    </div>
  );
}